import * as actions from 'actions/searchFilters';

const getDefaultFilterState = () => ({
  data: [],
  total: null,
  loading: false,
  error: null,
});

export default function searchFilters(state = {}, action) {
  const { type, payload } = action;

  switch (type) {
    case actions.RESET: {
      return {
        ...state,
        [payload.filterName]: getDefaultFilterState(),
      };
    }
    case actions.SEARCH_START: {
      return {
        ...state,
        [payload.filterName]: {
          ...state[payload.filterName],
          loading: true,
        },
      };
    }
    case actions.SEARCH_SUCCESS: {
      return {
        ...state,
        [payload.filterName]: {
          ...state[payload.filterName],
          loading: false,
          error: null,
          total: payload.total,
          data:
            payload.total !== state[payload.filterName].total
              ? payload.data
              : [...state[payload.filterName].data, ...payload.data],
        },
      };
    }

    default:
      return state;
  }
}
